/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AccountBilling32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 14.2v6.5c0 .718-.576 1.3-1.286 1.3H8.286C7.576 22 7 21.418 7 20.7v-6.5h18zm-4.5 3.9h-1.286c-.857 0-.857 1.3 0 1.3H20.5c.858 0 .858-1.3 0-1.3zm-3.857 0h-6.429c-.857 0-.857 1.3 0 1.3h6.429c.857 0 .857-1.3 0-1.3zM7 10.3C7 9.582 7.576 9 8.286 9h15.428c.71 0 1.286.582 1.286 1.3v1.3H7v-1.3z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default AccountBilling32;
